import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { PaginatedResponse, VehicleTemplate } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { SearchVehicleTemplatesParams } from '../api';
import { createVehicleTemplateApi, vehicleTemplateKeys } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UseVehicleTemplatesOptions extends SearchVehicleTemplatesParams {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useVehicleTemplates(
  options?: UseVehicleTemplatesOptions,
): UseQueryResult<PaginatedResponse<VehicleTemplate>> {
  const client = useApiClient('admin-auth');
  const api = createVehicleTemplateApi(client);

  const { enabled, ...filters } = options ?? {};

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: (): Promise<PaginatedResponse<VehicleTemplate>> => api.searchVehicleTemplates(filters),
    queryKey: vehicleTemplateKeys.list(filters),
    staleTime: LIST_STALE_TIME_MS,
  });
}
